import ReactApexChart from "react-apexcharts";
import React from "react";
import {FONT_SIZE_DATA_LABELS} from "../../../common/constants";
import {Card} from "antd";
import {formatWeekToISODate} from "../../../common/formatWeekToISODate";

type DarkStoreFirstColumnChartPropsType = {
    data: any
    weeks: any
}

export const DarkStoreFirstColumnChart = ({data, weeks}: DarkStoreFirstColumnChartPropsType) => {
    console.log(data)
    const options = {
        chart: {
            type: 'bar' as 'bar',
            toolbar: {
                show: false,
                tools: {
                    download: false
                }
            }
        },
        yaxis: {
            show: false,

        },
        //colors: settingsColors('', data),
        grid: {
            borderColor: '#202020',
            xaxis: {
                lines: {
                    show: false
                }
            },
            yaxis: {
                lines: {
                    show: true
                }
            },
            padding: {
                left: 40,
                right: 40,
                bottom: 20
            }
        },
        dataLabels: {
            enabled: true,
            textAnchor: 'middle' as 'middle',
            offsetY: -5,
            /*formatter: function (val: any, opts: any) {
                return chart === 'Глубина скидки' || chart === 'Доля акций' ? val + '%' : val
            },*/
            style: {
                fontSize: FONT_SIZE_DATA_LABELS,
                fontWeight: 600,
            },
            background: {
                enabled: false,
            }
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['#202020']

        },
        plotOptions: {
            bar: {
                columnWidth: '70%',
                endingShape: 'rounded',
                hideZeroBarsWhenGrouped: true,
                dataLabels: {
                    position: 'center',
                    orientation: /*count >= 20 ? 'vertical' as 'vertical' : */'horizontal' as 'horizontal',
                    hideOverflowingLabels: true,
                    total: {
                        enabled: true,
                        style: {
                            color: '#373d3f',
                            fontSize: '15px',
                            fontFamily: undefined,
                            fontWeight: 600
                        }
                    }
                },

            }
        },
        title: {
            text: 'Распределение количества товаров по дарксторам',
            align: 'center' as const,
            margin: 20,
            style: {

                fontSize: '16px',
                fontWeight: 'bold' as const,
                color: '#FFFFFF'
            },
        },

        xaxis: {
            type: 'category' as 'category',
            categories: weeks.map((el: any) => formatWeekToISODate(el) + ' (' + el.split('_').map(Number)[0] + ')'),
            labels: {
                show: true,
                rotate: -45,
                rotateAlways: weeks && weeks.length > 8,
                style: {
                    colors: 'white',
                    fontWeight: 14,
                    fontSize: '12',
                },
            },
        },
        legend: {
            position: 'top' as 'top',
            offsetY: -10,
            horizontalAlign: 'left' as const,
            showForZeroSeries: false,
            fontSize: '14px',
            labels: {
                colors: '#FFFFFF'
            },
            onItemClick: {
                toggleDataSeries: true
            },
            onItemHover: {
                highlightDataSeries: false
            },
        },
        tooltip: {
            enabled: true,
            theme: 'dark',
            x: {
                show: true,
            },
            marker: {
                show: true,
            }
        },
    }
    //const sortedData = [...data].sort((a, b) => a.name - b.name);

    return (
        <Card style={{background: '#293133', borderRadius: 20, marginTop: 20, marginBottom: 20}}>
            <ReactApexChart
                options={options}
                series={data}
                type={'bar'}
                height={500}
                style={{color: '#FFFFFF'}}
            />
        </Card>
    );
};

